import { MembershipProductType } from "../Types/MembershipProductType";

export interface MembershipProductTypeOption {
    value: number;
    textKey: string;
}

export const MembershipProductTypeOptions: MembershipProductTypeOption[] = [
    {
        value: MembershipProductType.MembershipType,
        textKey: 'MembershipProducts_ProductTypeMembership'
    },
    {
        value: MembershipProductType.Addon,
        textKey: 'MembershipProducts_ProductTypeAddon'
    },
];